const hero         = document.querySelector( '.hero' );
const heroVideo    = document.querySelector( '.hero video' );

if ( hero && heroVideo ) {
	// Play video on load.
	heroVideo.play();

}
